import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {

        // wait for next paint so framer-motion can mount elements
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: "auto"
                });
            });
        });

    }, [pathname]);

    return null;
}
